const INSURER_LOGOS = [
  { id: "mapfre",         alt: "MAPFRE",         src: "/brand/insurers/mapfre.png",         h: 22 },
  { id: "bci",            alt: "BCI Seguros",    src: "/brand/insurers/bci.png",            h: 30 },
  { id: "sura",           alt: "SURA",           src: "/brand/insurers/sura.png",           h: 26 },
  { id: "zurich",         alt: "Zurich",         src: "/brand/insurers/zurich.png",         h: 26 },
  { id: "hdi",            alt: "HDI Seguros",    src: "/brand/insurers/hdi.png",            h: 34 },
  { id: "reale",          alt: "Reale Seguros",  src: "/brand/insurers/reale.png",          h: 30 },
  { id: "renta-nacional", alt: "Renta Nacional", src: "/brand/insurers/renta-nacional.png", h: 26 },
];

// Franja horizontal de aseguradoras aliadas — respaldo visual debajo del Hero.
// Cada logo mantiene su alto característico (h) para preservar proporciones oficiales.
export const InsurerStrip = () => (
  <section
    data-testid="insurer-strip"
    className="border-b border-brand-ink/10 bg-white py-5 sm:py-6"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 sm:px-8 lg:flex-row lg:flex-nowrap lg:gap-4 xl:gap-6">
      <p className="max-w-xs text-center text-[13px] leading-snug text-gray-600 sm:max-w-md sm:text-sm lg:max-w-none lg:whitespace-nowrap lg:text-left lg:[font-size:clamp(10px,0.92vw,12.5px)]">
        Contamos con las{" "}
        <span className="font-semibold text-brand-ink">mejores condiciones del mercado</span>,
        con el respaldo de:
      </p>
      <div className="flex flex-1 flex-wrap items-center justify-center gap-x-6 gap-y-4 sm:gap-x-6 sm:gap-y-5 lg:flex-nowrap lg:justify-end lg:gap-x-4 xl:gap-x-6">
        {INSURER_LOGOS.map((l) => (
          <img
            key={l.id}
            data-testid={`insurer-logo-${l.id}`}
            src={l.src}
            alt={l.alt}
            loading="lazy"
            style={{ "--logo-h": `${l.h}px` }}
            className="h-[calc(var(--logo-h)*0.72)] w-auto opacity-80 transition-opacity duration-300 hover:opacity-100 sm:h-[calc(var(--logo-h)*0.8)] lg:h-[calc(var(--logo-h)*0.62)] xl:h-[calc(var(--logo-h)*0.75)]"
          />
        ))}
      </div>
    </div>
  </section>
);
